import { api } from './api'

/** Descarcă un fișier binar de la un endpoint autentificat (trimite Bearer token). */
/** Scoate mesajul serverului dintr-un raspuns de eroare venit ca Blob. */
async function eroareDinBlob(data: unknown): Promise<Error | null> {
  if (!(data instanceof Blob)) return null
  try {
    const body = JSON.parse(await data.text()) as { error?: { message?: string; details?: unknown } }
    if (!body?.error?.message) return null
    const err = new Error(body.error.message) as Error & { details?: unknown }
    err.details = body.error.details
    return err
  } catch {
    return null
  }
}

export async function downloadFile(url: string, filename: string): Promise<void> {
  let res
  try {
    res = await api.get(url, { responseType: 'blob' })
  } catch (err) {
    // La un raspuns 4xx/5xx, axios respinge cererea, iar continutul ramane un Blob
    // necitit — asa ajungea utilizatorul sa vada „A aparut o eroare" in loc de motiv
    // (ex. „Lipseste cursul BNR pentru EUR la ...").
    const real = await eroareDinBlob((err as { response?: { data?: unknown } })?.response?.data)
    throw real ?? err
  }

  // Un refuz (ex. 422 CURRENCY_NOT_SUPPORTED) vine tot ca Blob, fiindca am cerut
  // responseType: 'blob'. Fara pasul asta, utilizatorul vede „A aparut o eroare"
  // in loc de motivul real si lista documentelor.
  const blobRes = res.data as Blob
  if (blobRes?.type?.includes('application/json')) {
    throw (await eroareDinBlob(blobRes)) ?? new Error('Descărcarea a eșuat')
  }

  const blob = new Blob([res.data as BlobPart])
  const href = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = href
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(href)
}
